import { createAction } from '@reduxjs/toolkit';
import type * as I from 'core/api/coreApiClient';

export const showConfirmation = createAction('confirmation/showConfirmation', (
  confirmation: I.Confirm,
) => ({
  payload: {
    confirmation,
  },
}));

export const clearConfirmation = createAction('confirmation/clearConfirmation');
